var $ = require('jquery');
'use strict';

var PLUGIN_NAME = 'inlinePhotogallery';

var	DEFAULTS = {
};


/**
 * constructor
 * @param selector
 * @param options
 * @constructor
 */
var InlinePhotogallery = function (selector, options) {
	this.$t = $(selector);

	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;
	this.data = {};
	this.objects = {};
	this.animating = false;

	this.initialise_();
};

/**
 * init funkce
 * @private
 */
InlinePhotogallery.prototype.initialise_ = function() {
	var self = this;

	self.mapObjects_();

	if (self.objects.$items.length > 1) {
		self.buildHtml_();
		self.updateControls_();
		self.bindEvents_();
	}
};

InlinePhotogallery.prototype.mapObjects_ = function() {
	var self = this;

	self.objects.$items = self.$t.find('.item');
};

InlinePhotogallery.prototype.buildHtml_ = function() {
	var self = this;
	self.buildHtmlNavigation_();
};

InlinePhotogallery.prototype.buildHtmlNavigation_ = function() {
	var self = this;

	self.objects.$slideNavigation = $('<div class="nav" />');
	self.objects.$slideBtnPrev = $('<a href="#" class="nav-prev"><span class="ico ico-prev"></span></a>');
	self.objects.$slideBtnNext = $('<a href="#" class="nav-next"><span class="ico ico-next"></span></a>');
	self.$t.append(self.objects.$slideNavigation);
	self.objects.$slideNavigation.append(self.objects.$slideBtnPrev);
	self.objects.$slideNavigation.append(self.objects.$slideBtnNext);
};

InlinePhotogallery.prototype.bindEvents_ = function() {
	var self = this,
		$newItem;

	self.objects.$slideBtnPrev.on('click', function(e){
		$newItem = self.objects.$items.filter('.active').prev('.item');
		self.setActiveSlide_($newItem);
		e.preventDefault();
	});
	self.objects.$slideBtnNext.on('click', function(e){
		$newItem = self.objects.$items.filter('.active').next('.item');
		self.setActiveSlide_($newItem);
		e.preventDefault();
	});
};

InlinePhotogallery.prototype.setActiveSlide_ = function($newTarget) {
	var self = this,
		$currentTarget = self.objects.$items.filter('.active');

	if (($currentTarget != $newTarget) && ($newTarget.length > 0) && (!self.animating)) {
		self.finishSettingActiveSlide_($currentTarget, $newTarget);
	}
};

InlinePhotogallery.prototype.finishSettingActiveSlide_ = function($currentTarget, $newTarget) {
	var self = this,
		animatingClass = 'animating-from-right';

	self.animating = true;

	if ($newTarget.index() < $currentTarget.index()) {
		animatingClass = 'animating-from-left';
	}

	$newTarget.addClass(animatingClass);
	$newTarget.one('animationend webkitAnimationEnd oAnimationEnd', function () {
		$currentTarget.removeClass('active');
		$newTarget.removeClass(animatingClass).addClass('active');
		self.animating = false;
		self.updateControls_();
	});
};


InlinePhotogallery.prototype.updateControls_ = function() {
	var self = this,
		$activeItem = self.objects.$items.filter('.active');

		if ($activeItem.prev('.item').length == 0) {
			self.objects.$slideBtnPrev.hide();
		}
		else {
			self.objects.$slideBtnPrev.show();
		}

		if ($activeItem.next('.item').length == 0) {
			self.objects.$slideBtnNext.hide();
		}
		else {
			self.objects.$slideBtnNext.show();
		}
};

/**
 * decide, which methods will be "public"
 */
var API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new InlinePhotogallery(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.inline-photogallery.js